/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Feature_Realtime_DescriptionInputs */

const en_marketing_feature_realtime_description = /** @type {(inputs: Marketing_Feature_Realtime_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaborative notes, live task lists, and presence on Durable Objects.`)
};

const es_marketing_feature_realtime_description = /** @type {(inputs: Marketing_Feature_Realtime_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas colaborativas, listas de tareas en vivo y presencia sobre Durable Objects.`)
};

const fr_marketing_feature_realtime_description = /** @type {(inputs: Marketing_Feature_Realtime_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notes collaboratives, listes de tâches en direct et présence sur Durable Objects.`)
};

/**
* | output |
* | --- |
* | "Collaborative notes, live task lists, and presence on Durable Objects." |
*
* @param {Marketing_Feature_Realtime_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_feature_realtime_description = /** @type {((inputs?: Marketing_Feature_Realtime_DescriptionInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Feature_Realtime_DescriptionInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_feature_realtime_description(inputs)
	if (locale === "es") return es_marketing_feature_realtime_description(inputs)
	return fr_marketing_feature_realtime_description(inputs)
});